<div class="card">
  <div class="card-header">
    <h2 class="fs-3 fw-bold mb-0">{{ headline | translate }}</h2>
  </div>
  <div class="card-body">
    <app-form-field-select
      [field]="examControl"
      [options]="examSelectOptions"
      label="label.exams.exam"
      (selectionChange)="testSelected($event)"
    ></app-form-field-select>
    <app-form-field-text
      [field]="capacityControl"
      label="label.capacity"
    ></app-form-field-text>

    <ng-container *ngIf="showFormFields">
      <app-form-field-datetime
        [field]="timeControl"
        label="label.time"
      ></app-form-field-datetime>

      <!-- Default price -->
      <app-form-field-checkbox
        [field]="defaultPriceCheckboxControl"
        label="label.event-use-standard-price"
        [translateParameters]="{
          param1: this.defaultPrice,
          param2: this.currency
        }"
      >
      </app-form-field-checkbox>
      <app-form-field-monetary-amount
        *ngIf="!defaultPriceCheckboxControl.value"
        [field]="defaultPriceControl"
        label="label.registration-price"
        [currency]="currency"
      ></app-form-field-monetary-amount>

      <!-- Reduced price -->
      <app-form-field-checkbox
        [field]="reducedPriceCheckboxControl"
        label="label.event-provide-reduced-price"
      >
      </app-form-field-checkbox>
      <app-form-field-monetary-amount
        *ngIf="reducedPriceCheckboxControl.value"
        [field]="reducedPriceControl"
        label="label.registration-reduced-price"
        [currency]="currency"
      ></app-form-field-monetary-amount>

      <app-form-field-datetime
        [field]="registrationPeriodStartControl"
        label="label.registration-period-start"
      ></app-form-field-datetime>
      <app-form-field-datetime
        [field]="registrationPeriodEndControl"
        label="label.registration-period-end"
        [min]="startingPointForRegistrationPeriodEnd"
      ></app-form-field-datetime>
    </ng-container>
  </div>

  <div class="card-footer d-flex justify-content-end">
    <button
      (click)="delete()"
      class="btn btn-primary me-3"
      [disabled]="deleteButtonDisabled"
    >
      {{ 'button.delete' | translate }}
    </button>
    <button
      (click)="submit()"
      class="btn btn-primary"
    >
      {{ 'button.save' | translate }}
    </button>
  </div>
</div>
<button
  (click)="closeForm.emit()"
  class="btn btn-primary rounded-circle d-flex align-items-center justify-content-center close-button"
>
  <i class="bi bi-x-lg"></i>
</button>
